import { h } from '@stencil/core';
import { i18n } from 'i18n';

interface SegmentConnectionProps {
  time: string;
  lastStop: boolean;
  city?: string;
  planeChange: boolean;
}

export default function SegmentConnection({ time, lastStop, city, planeChange = false }: SegmentConnectionProps) {
  const parseTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number);
    return `${hours} h ${minutes} m`;
  };

  return (
    <span class={{ 'segment-connection-container -eva-3-mb-md -eva-3-mt-md -eva-3-p-sm': true, 'total-duration': lastStop }}>
      <span class="detail-time">
        <span class="detail-time-wrapper">
          <div class="-eva-3-pr-sm">
            <span class="connection">
              {lastStop ? (
                <span class="wait-duration">
                  <span class="text">
                    {i18n.t.flightDetailModal.duration}:<span class="connection-text-duration -eva-3-bold">&nbsp;{parseTime(time)}&nbsp;</span>
                  </span>
                </span>
              ) : (
                <span class="wait-duration">
                  <i class="eva-3-icon-time"></i>
                  <span class="text">
                    &nbsp; {i18n.t.flightDetailModal.layover.wait}
                    <span class="connection-text-duration -eva-3-bold">&nbsp;{time}&nbsp;</span>
                    {i18n.t.flightDetailModal.layover.in}&nbsp;{city}&nbsp;
                  </span>
                  {planeChange ? (
                    <span class="connection-type">({i18n.t.flightDetailModal.layover.planeChange})</span>
                  ) : (
                    <span class="connection-type">({i18n.t.flightDetailModal.layover.samePlane})</span>
                  )}
                </span>
              )}
            </span>
          </div>
        </span>
      </span>
    </span>
  );
}
